import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Box } from '@hivewatch/dark'

import { getRoleDisplayName } from '@/features/managed-accounts'
import { Notification } from '@/graphql/appsync-notifications'

import { getNotificationToastTokens } from '../styles/tokens'

export const AudioNotificationTitle = ({
  notification,
}: {
  notification: Notification
}) => {
  const { t } = useTranslation()
  const tokens = getNotificationToastTokens(useLightMode())
  return (
    <Box color={tokens.textPrimary} lineClamp={2} textStyle='body-bold'>
      <Box
        as='span'
        color={tokens.incidentLink}
        data-testid='AudioNotificationTitle:title'
      >
        {`${getRoleDisplayName(notification.audioMessageUserRole)} ${
          notification.audioMessageUserName
        }`}
      </Box>{' '}
      {t('common:notification_sent_voice_message')}{' '}
      <Box
        as='span'
        color={tokens.incidentLink}
        data-testid='AudioNotificationTitle:details'
      >
        {notification.incidentDisplayId} {notification.incidentName}
      </Box>
    </Box>
  )
}
